import { render, staticRenderFns } from "./Words.vue?vue&type=template&id=4746628e&"
import script from "./Words.vue?vue&type=script&lang=ts&"
export * from "./Words.vue?vue&type=script&lang=ts&"
import style0 from "./Words.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports